import { useQueryClient } from '@tanstack/react-query';
import { unsetCommonHeaders } from '_api/base';
import useApiMutation from '_api/mutations/useApiMutation';

export const SIGN_OUT_QUERY_KEY = 'sign-out';

export const useSignOut = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, {}>(
    () => '/auth/sign-out',
    'put',
    {},
    {
      mutationKey: [SIGN_OUT_QUERY_KEY],
      onSettled: () => {
        unsetCommonHeaders();
        localStorage.clear();
        queryClient.clear();
      },
    },
  );
};
